import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="music-file-selector"
export default class extends Controller {
  static targets = ["selectAll", "checkbox"]

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
  }

  assignToPlaylist(event) {
    event.preventDefault()

    const assignUrl = event.currentTarget.href
    const checkedIds = this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)

    if (checkedIds.length === 0) {
      alert('Please select at least one track')
      return
    }

    const formData = new FormData()
    checkedIds.forEach(id => formData.append('music_file_ids[]', id))

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    fetch(assignUrl, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Accept': 'text/vnd.turbo-stream.html'
      },
      body: formData
    }).then(response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html)

        this.checkboxTargets.forEach(cb => cb.checked = false)
        if (this.hasSelectAllTarget) {
          this.selectAllTarget.checked = false
        }
      })
  }
}
